<template>
  <v-container fluid tag="section">
    <v-layout justify-center style="flex-wrap: wrap">
      <v-btn small @click="createCausale" color="primary">{{
        $t("create_causale")
      }}</v-btn>
    </v-layout>
    <v-row>
      <v-col cols="12">
        <DataTables
          @editCausale="editCausale"
          @viewCausale="viewCausale"
          :headers="headers"
          :tableData="tableData"
        ></DataTables>
      </v-col>
    </v-row>
    <edit-causale ref="editCausaleDialog" @isUpdated="loadTable"></edit-causale>
  </v-container>
</template>

<script>
import gestCausale from "@/app/contab/gestCausale.vue";
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";

export default {
  name: "list-causali",
  components: {
    DataTables,
    "edit-causale": gestCausale,
  },
  data() {
    return {
      headers: [
        { text: this.$t("code"), value: "cauId" },
        { text: this.$t("text"), value: "descr", type: "html" },
        { text: this.$t("reg_serie"), value: "serie" },
        { text: this.$t("if_protocol"), value: "ifProtocol", type: "icons" },
        { text: this.$t("if_receipt"), value: "ifReceipt", type: "icons" },
        { text: this.$t("if_cdx"), value: "ifCdx", type: "icons" },
        { text: this.$t("if_giroconto"), value: "ifGiroconto", type: "icons" },
        { text: this.$t("if_cdc"), value: "dexCdc" },
        { text: this.$t("if_cdp"), value: "dexCdp" },
        { text: this.$t("cau_default_for"), value: "default4", type: "icons" },
        {
          text: this.$t("options"),
          value: "options",
          type: "buttons",
        },
      ],
      tableData: [],
    };
  },

  methods: {
    createCausale(item) {
      this.$refs.editCausaleDialog.open("ADD", null);
    },
    editCausale(item) {
      this.$refs.editCausaleDialog.open("EDIT", item.cauId);
    },
    viewCausale(item) {
      this.$refs.editCausaleDialog.open("VIEW", item.cauId);
    },
    loadTable() {
      let _ = this;
      _.tableData = [];
      _.isFetching = true;
      this.chiamataAxios("GET", "/auth/contab/listCausali").then((response) => {
        _.tableData = response.data.map(function (item) {
          if (item.ifProto)
            item.ifProtocol = [
              {
                icon: "mdi-check",
                color: "green",
                text: _.$t("yes"),
              },
            ];
          if (item.ifRicevuta)
            item.ifReceipt = [
              {
                icon: "mdi-check",
                color: "green",
                text: _.$t("yes"),
              },
            ];
          if (item.ifCdx)
            item.ifCdx = [
              {
                icon: "mdi-check",
                color: "green",
                text: _.$t("yes"),
              },
            ];
          if (item.ifGiroconto)
            item.ifGiroconto = [
              {
                icon: "mdi-check",
                color: "green",
                text: _.$t("yes"),
              },
            ];
          item.default4 = [];
          if (
            item.defaultFor.includes("ORDER_BUY_PRODUCT") ||
            item.defaultFor.includes("ORDER_BUY_CREDITS") ||
            item.defaultFor.includes("ORDER_BUY_TICKET") ||
            item.defaultFor.includes("ORDER_BUY_DIGITAL")
          )
            item.default4.push({
              icon: "mdi-cube-outline",
              color: "secondary",
              text: _.$t("cau_products"),
            });
          if (
            item.defaultFor.includes("ORDER_EVENTO") ||
            item.defaultFor.includes("ORDER_UPGRADE_EVENTO")
          )
            item.default4.push({
              icon: "mdi-calendar-account-outline",
              color: "secondary",
              text: _.$t("cau_evento"),
            });
          if (item.defaultFor.includes("ORDER_TESSERAMENTO"))
            item.default4.push({
              icon: "mdi-credit-card-outline",
              color: "secondary",
              text: _.$t("cau_tessera"),
            });
          if (
            item.defaultFor.includes("ORDER_BUY_AFFILIATION") ||
            item.defaultFor.includes("ORDER_BUY_AFFILIATION_CARDS") ||
            item.defaultFor.includes("ORDER_SELL_AFFILIATION") ||
            item.defaultFor.includes("ORDER_SELL_AFFILIATION_CARDS")
          )
            item.default4.push({
              icon: "mdi-handshake-outline",
              color: "secondary",
              text: _.$t("cau_affiliations"),
            });
          if (item.defaultFor.includes("PAY_INVOICE"))
            item.default4.push({
              icon: "mdi-cash",
              color: "secondary",
              text: _.$t("cau_pay_invoice"),
            });
          item.options = [
            {
              icon: "mdi-magnify",
              color: "success",
              text: _.$t("view_causale"),
              function: "viewCausale",
            },
            {
              icon: "mdi-pencil",
              color: "primary",
              text: _.$t("edit_causale"),
              function: "editCausale",
            },
          ];

          return item;
        });
        _.isFetching = false;
      });
    },
  },
  mounted() {
    this.loadTable();
  },
};
</script>